import { StyleSheet, View } from "react-native";
import { theme } from "@config/Theme";
import { ReceiveDeliveryFeature } from "../../features/receive-delivery/ReceiveDelivery.feature";
import { useAuth } from "@auth/useAuth";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { useEffect, useMemo, useState } from "react";
import { Loading } from "@components/Loading";
import { BackHeader } from "@components/BackHeader";
import { useTranslation } from "react-i18next";

export const ReceiveDeliveryPage = ({ navigation, route }: any) => {
  let { counterId, signed } = route.params;
  const { user, signOut } = useAuth();
  const { t } = useTranslation("recipient");
  const [guid, setGuid] = useState<string>(counterId);
  const [isMandatoryDniCollect, setIsMandatoryDniCollect] =
    useState<boolean>(false);

  const userSignature = useMemo(() => user?.profile?.signature ?? "", [user]);

  const back = () => {
    if (navigation.canGoBack()) {
      navigation.goBack();
    } else {
      signOut();
      window.location.reload();
    }
  };

  const redirectToSignature = () => {
    navigation.navigate("Signature", {
      counterId: guid,
    });
  };

  useEffect(() => {
    if (guid === "0") {
      AsyncStorage.getItem("invitation_ids").then((value) => {
        if (!value) return;
        try {
          const ids = JSON.parse(value);
          setIsMandatoryDniCollect(ids.isMandatoryDniCollect ?? false);
          setGuid(ids.counterId);
        } catch (error) {
          window.location.reload();
        }
      });
    }
  }, [guid]);

  if (!signed) {
    if (userSignature === "" || isMandatoryDniCollect) {
      redirectToSignature();
      return <></>;
    }
  }

  if (guid === "0") return <Loading />;

  return (
    <>
      <BackHeader back={back} title={t("receiveDelivery_page_title")!} />
      <View style={styles.container} key={user.profile.dni}>
        <ReceiveDeliveryFeature back={back} id={guid} />
      </View>
    </>
  );
};

const styles = StyleSheet.create({
  container: {
    marginTop: 50,
    backgroundColor: theme.colors.background,
    flex: 1,
  },
});
